/** @jsx jsx */

import { FormattedMessage } from 'react-intl';
import { Fragment, PropsWithChildren } from 'react';

import { jsx, css } from '@emotion/core';
import { Colors, Icon, Spacer } from '@zapier/design-system';

const Styles = {
  help: css`
    display: flex;
    margin-bottom: 12px;
  `,
  helpIcon: css`
    color: ${Colors.GrayWarm7};
    margin-right: 10px;
  `,
  content: css`
    color: inherit;
    line-height: 1.5em;
  `,
};

type Props = PropsWithChildren<{}>;

const GuideSidebarFooter = (props: Props) => {
  return (
    <Fragment>
      <div css={Styles.help}>
        <Icon css={Styles.helpIcon} name="commentBlankFill" size={18} />
        <Spacer width={10} />
        <FormattedMessage defaultMessage="Get Help" id="headings-get-help" />
      </div>
      <div css={Styles.content}>{props.children}</div>
    </Fragment>
  );
};

export default GuideSidebarFooter;
